import { Controller } from "@hotwired/stimulus"

// lm items enter the pack size as a length in mm
export default class extends Controller {
  static targets = ["label", "input"]

  connect() {
    this.unitSelect = document.getElementById("inventory_item_unit")
    this.update = this.update.bind(this)
    this.unitSelect?.addEventListener("change", this.update)
    this.update()
  }

  disconnect() {
    this.unitSelect?.removeEventListener("change", this.update)
  }

  update() {
    const lm = this.unitSelect?.value === "lm"
    this.labelTarget.textContent = lm ? "Length (mm)" : "Pack Size (in item unit)"
    this.inputTarget.placeholder = lm ? "e.g. 4000" : "e.g. 1000"
  }
}
